// extracted by mini-css-extract-plugin
export default {"Outer":"Pie_Outer__nLt5d","innerText":"Pie_innerText__rJdwY","number":"Pie_number__Py5cI","afterDecimal":"Pie_afterDecimal__a+5jD","totalDiv":"Pie_totalDiv__sXFNc"};